import { render, staticRenderFns } from "./Replay.vue?vue&type=template&id=36bd45ff&scoped=true&"
import script from "./Replay.vue?vue&type=script&lang=js&"
export * from "./Replay.vue?vue&type=script&lang=js&"
import style0 from "./Replay.vue?vue&type=style&index=0&id=36bd45ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bd45ff",
  null
  
)

export default component.exports